import React, { Component } from 'react';
import { Text } from 'react-native';
import { Colors } from '../components';

class Icon extends Component {

  render() {

    const iconName  = this.props.name;
    const style     = this.props.style;
    const isSolid   = this.props.solid || false;
    const iconSize  = this.props.size  || 25;
    const iconColor = this.props.color || Colors.PRIMARY;
    const hide      = this.props.hide  || false;

    const iconRegular = regularIcons[iconName];
    const iconBrand   = brandIcons[iconName];

    var fontFamily  = 'FontAwesome5Free-Regular';
    var iconUnicode = '';

    if (iconRegular) {
      fontFamily  = isSolid ? 'FontAwesome5Free-Solid' : 'FontAwesome5Free-Regular';
      iconUnicode = iconRegular;
    } else if (iconBrand) {
      fontFamily ='FontAwesome5Brands-Regular';
      iconUnicode = iconBrand;
    } else if (!iconRegular && !iconBrand) {
      return null;
    }

    if (hide) {
      return null;
    }

    return <Text style={{ fontFamily: fontFamily,
                          fontSize: iconSize,
                          color: iconColor,
                          ...style
                        }}>{ iconUnicode }</Text>
  }

}

const regularIcons = {
  'address-book': '\uf2b9',
  'address-card': '\uf2bb',
  'arrow-up': '\uf062',
  'arrow-circle-up': '\uf0aa',
  'arrow-circle-right': '\uf0a9',
  'arrow-circle-left': '\uf0a8',
  'bars': '\uf0c9',
  'calendar-alt': '\uf073',
  'camera': '\uf030',
  'cat': '\uf6be',
  'check': '\uf00c',
  'check-circle': '\uf058',
  'check-square': '\uf14a',
  'chevron-down': '\uf078',
  'chevron-right': '\uf054',
  'chevron-left': '\uf053',
  'circle': '\uf111',
  'circle-chevron-left': '\uf137',
  'circle-chevron-right': '\uf138',
  'clipboard': '\uf328',
  'clipboard-check': '\uf46c',
  'cog': '\uf013',
  'comment' : '\uf075',
  'credit-card': '\uf09d',
  'dog': '\uf6d3',
  'dot-circle': '\uf192',
  'edit': '\uf044',
  'ellipsis-h': '\uf141',
  'envelope': '\uf0e0',
  'exclamation-circle': '\uf06a',
  'file-image': '\uf1c5',
  'file-pdf' : '\uf1c1',
  'hippo': '\uf6ed',
  'horse': '\uf6f0',
  'hourglass-start': '\uf251',
  'id-badge': '\uf2c1',
  'list-ul': '\uf0ca',
  'lock': '\uf023',
  'microphone-slash': '\uf131',
  'minus-circle': '\uf056',
  'notes-medical': '\uf481',
  'paperclip': '\uf0c6',
  'phone': '\uf095',
  'photo-film': '\uf87c',
  'plus-circle': '\uf055',
  'sign-in-alt' : '\uf2f6',
  'sign-out-alt': '\uf2f5',
  'square': '\uf0c8',
  'store-alt': '\uf54f',
  'sync-alt': '\uf2f1',
  'times-circle': '\uf057',
  'trash': '\uf2ed',
  'university': '\uf19c',
  'up': '\uf357',
  'user': '\uf007',
  'users': '\uf0c0',
  'user-md': '\uf0f0',
  'user-minus': '\uf503',
  'user-plus': '\uf234',
  'video': '\uf03d',
  'video-slash': '\uf4e2',
}

const brandIcons = {
  'cc-amex': '\uf1f3',
  'cc-discover': '\uf1f2',
  'cc-mastercard': '\uf1f1',
  'cc-stripe': '\uf1f5',
  'cc-visa': '\uf1f0',
}

export default Icon
